/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MeasurementSystem {
    Metric = 'Metric',
    Imperial = 'Imperial'
}

export function MeasurementSystemFromJSON(json: any): MeasurementSystem {
    return MeasurementSystemFromJSONTyped(json, false);
}

export function MeasurementSystemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasurementSystem {
    return json as MeasurementSystem;
}

export function MeasurementSystemToJSON(value?: MeasurementSystem | null): any {
    return value as any;
}

